import { render } from "./EventDetailAddPage.vue?vue&type=template&id=7bafe0ad&scoped=true"
import script from "./EventDetailAddPage.vue?vue&type=script&lang=js"
export * from "./EventDetailAddPage.vue?vue&type=script&lang=js"

import "./EventDetailAddPage.vue?vue&type=style&index=0&id=7bafe0ad&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bafe0ad"]])

export default __exports__